import { ElementRef, Injectable } from '@angular/core';
import { DateSelectEntity } from '../models/calendar-single.interfaces';

/**
 * Date Common service for working with calendar widgets
 * and any other services.
 */
@Injectable({
  providedIn: 'root'
})
export class DateCommonService {
  /**
   *  To focus the selected date
   */

  // eslint-disable-next-line complexity
  focusOnSelectedDate(value: DateSelectEntity, elementRef: ElementRef) {
    const valueArray = value && value.value ? value.value.split('/') : '';

    if (
      valueArray &&
      valueArray[1] &&
      elementRef.nativeElement.querySelector(
        `.calendar-table-day__current--${parseInt(valueArray[1], 10)}`
      )
    ) {
      elementRef.nativeElement
        .querySelector(
          `.calendar-table-day__current--${parseInt(valueArray[1], 10)}`
        )
        .focus();
    }
  }
}
